export const PREVIEW_BASE_PATH_STORAGE_KEY = 'lpps-preview-base-path';

// Entra allows one fixed redirect URI. All pull request previews share the root of the
// preview host, and the redirect page there reads this value to send the user back.
export const rememberPreviewBasePath = (
  basePath: string = import.meta.env.BASE_URL,
  storage: Pick<Storage, 'setItem'> = sessionStorage,
): void => {
  if (basePath === '/') {
    return;
  }
  storage.setItem(PREVIEW_BASE_PATH_STORAGE_KEY, basePath);
};
